(function () {
  'use strict';

  var API_BASE = 'https://config-looprx.getadrip.shop/api/ed-assessment/submit';
  var X_TENANT = 'getadrip-db-GtD9mXcR7vFs2Z';

  function apiHeaders() {
    return {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-Tenant': X_TENANT
    };
  }

  /** Maps form values (e.g. bp-normal) to API enum strings (e.g. normal) per submit contract. */
  function mapBloodPressureCategory(raw) {
    if (!raw) return '';
    var map = {
      'bp-normal': 'normal',
      'bp-low': 'low',
      'bp-high': 'high'
    };
    return map[raw] != null ? map[raw] : raw;
  }

  function getSubmitUrl() {
    var el = document.getElementById('assessment-app');
    if (el) {
      var u = el.getAttribute('data-ed-api-submit-url');
      if (u && String(u).trim()) {
        u = String(u).trim();
        if (u.indexOf('http://') === 0 || u.indexOf('https://') === 0) return u;
        if (u.indexOf('/') === 0) return window.location.origin + u;
        return u;
      }
    }
    return API_BASE;
  }

  function ans(id) {
    var s = window.gadAssessmentState;
    if (!s || !s.answers) return '';
    return s.answers[id] || '';
  }

  function collectApiPayload() {
    var w = ans('q6');
    var h = ans('q6a');

    return {
      patient_email: ans('patient_email'),
      first_name: ans('first_name'),
      last_name: ans('last_name'),
      date_of_birth: ans('dob'),
      used_ed_treatment_with_us_before: ans('q1'),
      treatment_preference: '',
      age_range: ans('q4'),
      blood_pressure_checked_past_6_months: ans('q4b'),
      blood_pressure_category: mapBloodPressureCategory(ans('q4c')),
      blood_pressure_medication: ans('q4d'),
      blood_pressure_medication_details: ans('q4e'),
      ed_history_statements: ans('q4a'),
      allergies: ans('q5'),
      lactose_tolerance: ans('q5a'),
      other_allergy_details: ans('q5b'),
      weight: w ? w + ' kg' : '',
      height: h ? h + ' cm' : '',
      review_statements: ans('q7'),
      unstable_angina_or_heart_failure: ans('q7a'),
      chest_pain_or_sob_details: ans('q7b'),
      liver_kidney_impairment_details: ans('q8'),
      transplant_details: ans('q9'),
      retinal_disorder_details: ans('q10'),
      irregular_heartbeat_symptoms: ans('q11'),
      priapism_risk_acceptance: ans('q11a'),
      irregular_heartbeat_details_blood_disorder: ans('q11b'),
      blood_disorder_condition_details: ans('q11c'),
      palpitations_dizziness_fainting_or_sob: ans('q12'),
      irregular_heartbeat_details: ans('q12a'),
      blood_disorder_details: ans('q13'),
      penile_deformity_details: ans('q14'),
      meds_recreational_drugs: ans('q15'),
      meds_cimetidine_azole_macrolide_selected: ans('q15a'),
      meds_cimetidine_azole_macrolide_details: ans('q15a_condition'),
      meds_citalopram_escitalopram_selected: ans('q16'),
      meds_citalopram_escitalopram_details: ans('q16_condition'),
      meds_rifampicin_hiv_pi_details: ans('q17'),
      meds_alpha_blockers_selected: ans('q18'),
      meds_alpha_blockers_conditions: ans('q18_condition'),
      meds_rifampicin_hiv_pi_selected: ans('q18b'),
      meds_rifampicin_hiv_pi_conditions: ans('q18b_condition'),
      alpha_blockers_dose_changed_last_1_month: ans('q18a_dose_changed'),
      meds_alpha_blockers_details: ans('q18a'),
      meds_diltiazem_group_selected: ans('q19'),
      meds_diltiazem_group_conditions: ans('q19_condition'),
      diltiazem_group_dose_changed_last_1_month: ans('q19a_dose_changed'),
      meds_diltiazem_group_details: ans('q19a'),
      meds_tki_selected: ans('q20'),
      meds_tki_details: ans('q20_condition'),
      previous_ed_treatments: ans('q21'),
      viagra_highest_dose: ans('q21a'),
      viagra_expectations_met: ans('q21b'),
      viagra_why_not_met: ans('q21c'),
      viagra_duration_25mg: ans('q21d'),
      viagra_doses_taken: ans('q21e'),
      cialis_highest_dose: ans('q22'),
      cialis_expectations_met: ans('q22a'),
      cialis_why_not_met: ans('q22b'),
      levitra_expectations_met: ans('q23'),
      levitra_why_not_met: ans('q23a'),
      spedra_expectations_met: ans('q24'),
      spedra_why_not_met: ans('q24a'),
      penile_pumps_details: ans('q25'),
      penile_injections_details: ans('q26'),
      herbal_ayurvedic_details: ans('q28'),
      ed_treatment_other_details: ans('q29'),
      medical_history_statement: ans('q31'),
      medical_history_details: ans('q31a'),
      current_medications_list: ans('q31b'),
      inform_gp: ans('q31c'),
      gp_email: ans('q31d'),
      category_id:2
    };
  }

  function submitAssessment() {
    var payload = collectApiPayload();
    var submitUrl = getSubmitUrl();

    return fetch(submitUrl, {
      method: 'POST',
      headers: apiHeaders(),
      body: JSON.stringify(payload),
      mode: 'cors',
      credentials: 'include',
      redirect: 'manual'
    })
    .then(function (res) {
      var st = res.status;
      var redirected =
        res.type === 'opaqueredirect' ||
        st === 301 ||
        st === 302 ||
        st === 303 ||
        st === 307 ||
        st === 308 ||
        (st === 0 && res.type === 'opaqueredirect');
      if (redirected) {
        return { success: false, error: 'redirect', status: st, responseType: res.type };
      }
      return res.text().then(function (text) {
        if (!text || !text.trim()) {
          return { success: false, error: 'empty_body', status: st };
        }
        try {
          return JSON.parse(text);
        } catch (e) {
          return { success: false, error: 'invalid_json', status: st, snippet: text.slice(0, 200) };
        }
      });
    })
    .then(function (data) {
      return data;
    })
    .catch(function (err) {
      return { success: false, error: String(err && err.message ? err.message : err) };
    });
  }

  window.gadAssessmentApi = {
    collectPayload: collectApiPayload,
    submit: submitAssessment,
    getSubmitUrl: getSubmitUrl,
    defaultSubmitUrl: API_BASE
  };
})();
